"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5592],{

/***/ 75592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ FooterContacts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26628);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Footer_scss_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77718);
/* harmony import */ var _Footer_scss_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Footer_scss_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var SocialLinks = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3997), __webpack_require__.e(7472)]).then(__webpack_require__.bind(__webpack_require__, 37472));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37472)
            ];
        }
    }
});
function FooterContacts(param) {
    var pageProps = param.pageProps;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var site_locale = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return state.locale.code;
    });
    var phone = (ref1 = (ref = pageProps.dispatches) === null || ref === void 0 ? void 0 : ref.setCoreConfigs.general_info_general_phone) === null || ref1 === void 0 ? void 0 : ref1.value;
    var email = (ref3 = (ref2 = pageProps.dispatches) === null || ref2 === void 0 ? void 0 : ref2.setCoreConfigs.general_info_general_footer_email) === null || ref3 === void 0 ? void 0 : ref3.value;
    var address = (ref6 = (ref5 = (ref4 = pageProps.dispatches) === null || ref4 === void 0 ? void 0 : ref4.setCoreConfigs.general_info_general_footer_address) === null || ref5 === void 0 ? void 0 : ref5.find(function(el) {
        return (el === null || el === void 0 ? void 0 : el.locale_code) === site_locale;
    })) === null || ref6 === void 0 ? void 0 : ref6.value;
    /*TODO fix this locale in server*/ // const address = pageProps.dispatches.setCoreConfigs.general_info_general_footer_address[0].value;
    var contacts = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
        className: (_Footer_scss_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["footer-contacts__contacts"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: (_Footer_scss_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().contactsAddress),
                children: email ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    dangerouslySetInnerHTML: {
                        __html: email
                    }
                }) : ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: (_Footer_scss_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().contactsAddress),
                children: phone ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: "tel:".concat(phone),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        children: phone
                    })
                }) : ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: (_Footer_scss_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().contactsAddress),
                children: address ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: address
                    }
                }) : ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SocialLinks, {
                    className: (_Footer_scss_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["footer-newsletter__social-links"]),
                    shape: "circle",
                    pageProps: pageProps
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_Footer_scss_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["footer-newsletter__social-links"]), " ").concat((_Footer_scss_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["footer-contacts"])),
        children: contacts
    });
}


/***/ })

}]);